export const SESSION_USER_UPDATED_EVENT = "session-user-updated";

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch (_e) {
    return {};
  }
};

export const updateStoredUser = (patch = {}) => {
  const current = getStoredUser();
  const merged = { ...current, ...patch };
  localStorage.setItem("user", JSON.stringify(merged));
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(SESSION_USER_UPDATED_EVENT, { detail: merged })
    );
  }
  return merged;
};

export const clearStoredSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("user");
  localStorage.removeItem("permissions");
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(SESSION_USER_UPDATED_EVENT, { detail: {} })
    );
  }
};

export const redirectToLogin = () => {
  if (typeof window !== "undefined") {
    window.location.replace("/login");
  }
};
